import { fromPairs } from 'lodash';
import { useMemo } from 'react';
import type { ResourceManagementPermissionsResponse } from 'api/resource-management/types';
import {
  FieldType,
  MultiUserField,
  SourceType,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useNativeUsersQuery } from 'queries/members';

export const useTeamMembersField = (
  fieldId: number,
  peopleIHaveAccessTo?: ResourceManagementPermissionsResponse,
): {
  teamMemberField: MultiUserField;
  isLoading: boolean;
} => {
  const { data: users, isLoading: isUserLoading } = useNativeUsersQuery();
  const fieldLabel = useTranslation('project.fields.team_members');

  return useMemo(
    () => ({
      teamMemberField: {
        fieldId,
        fieldName: 'teamMembers',
        fieldLabel,
        type: FieldType.MultiUser,
        private: false,
        userCreated: false,
        metaData: {
          users: {
            by_user_id: fromPairs((users ?? []).map((x) => [x.userId, x])),
            active_user_ids: (users ?? []).map((x) => x.userId),
            non_external_user_ids: (users ?? [])
              .map((x) => x.userId)
              .filter((x) =>
                peopleIHaveAccessTo ? peopleIHaveAccessTo[x] : true,
              ),
            by_project_id: {},
          },
          required: true,
        },
        sourceType: SourceType.Project,
      },
      isLoading: isUserLoading,
    }),
    [fieldId, fieldLabel, isUserLoading, peopleIHaveAccessTo, users],
  );
};
